const errors = {
  invalidPhoneNumber: 'Неверный номер телефона',
  confirmationCodeTooShort: 'Код подтверждения должен состоять не менее 4 символов',
  requiredField: name => `Пожалуйста, укажите ${name.toLowerCase()}`,
  positiveField: 'Поле должно быть положительным числом',
  integerField: 'Поле должно быть целочисленным',
  notFoundPage: 'Страница не найдена',
  noResultsFor: query => `Ничего не найдено по запросу "${query}"`,
  emptyList: items => `${items} пуст`,
  serverDown: 'Что-то произошло на нашей стороне, пожалуйста попробуйте еще раз позже',
  notFoundMarkers: 'По данной компании не было найдено ни одного маркера',
  updatingScoreTakesTime:
    'Актуальные данные по скоринговому балла будут доступны в течение 5 минут',
  couldNotUpdateScore: 'Не удалось обновить балл',
};

export default errors;
